export default __webpack_public_path__ + "static/laveba-logo-3f743d1cc33c2cba3836b98d32dc1789.png";